import { render } from "./Home.vue?vue&type=template&id=dfebcd6c"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=dfebcd6c&lang=scss"
script.render = render

export default script